const BASE_URL =  'https://cassuss.com'
export default (category) => ({
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": category.name,
  "description": category.description,
  "url": `${BASE_URL}/category/${category.slug}`
})
